import React from 'react';

import Header from './header';
import Footer from './footer';

const Layout = ({ children }) => (
  <div className='max-w-screen-xl mx-auto min-h-screen flex flex-col'>
    <Header />
    <main className='flex-1 px-4 sm:px-6 lg:px-8 flex items-center justify-center lg:justify-start'>
      {children}
    </main>
    <Footer />
  </div>
);

export default Layout;
